import { ReactNode } from 'react';

import classNames from 'classnames';
import './styles.scss';

interface FormRowProps {
  children: ReactNode;
  columns?: number;
  minColumnWidth?: number;
  layout?: 'grid' | 'flex';
  className?: string;
}

export const FormRow = ({
  children,
  columns = 3,
  minColumnWidth,
  layout = 'grid',
  className,
}: FormRowProps) => {
  const gridTemplateColumns = minColumnWidth
    ? `repeat(auto-fit, minmax(${minColumnWidth}px, 1fr))`
    : `repeat(${columns}, 1fr)`;

  return (
    <div
      className={classNames('backtesting-form-row', `backtesting-form-row--${layout}`, className)}
      style={layout === 'grid' ? { gridTemplateColumns } : undefined}
    >
      {children}
    </div>
  );
};
